class ConfigConstructorModel {
  constructor({
    logging = null,
    loggingLevel = null,
    loggingCategories = null,
    loggingAlwaysWarn = null,
    loggingAlwaysError = null,
    sessionLength = null,
    silentMode = null,
    allowTrackCategories = [],
  } = {}) {
    this.logging = logging;
    this.loggingLevel = loggingLevel;
    this.loggingCategories = loggingCategories;
    this.loggingAlwaysWarn = loggingAlwaysWarn;
    this.loggingAlwaysError = loggingAlwaysError;
    this.sessionLength = sessionLength;
    this.silentMode = silentMode;
    this.allowTrackCategories = allowTrackCategories;
  }
  json() {
    return {
      logging: this.logging,
      loggingLevel: this.loggingLevel,
      loggingCategories: this.loggingCategories,
      loggingAlwaysWarn: this.loggingAlwaysWarn,
      loggingAlwaysError: this.loggingAlwaysError,
      sessionLength: this.sessionLength,
      silentMode: this.silentMode,
      allowTrackCategories: this.allowTrackCategories,
    };
  }
}

module.exports = ConfigConstructorModel;
